import { consoleEvents } from '@pb/utils'

import { fetchNotifications, markNotificationsAsRead } from '../requests'
import {
  fetchNotificationsStart,
  fetchNotificationsSuccess,
  fetchNotificationsFail,
  markAsRead,
  allMessagesRead,
} from './actions'
import { normalizeNotifications } from './normalize'
import selectors from './selectors'

export const operationFetchNotifications = () => (dispatch) => {
  dispatch(fetchNotificationsStart())

  return fetchNotifications()
    .then((result) => {
      const normalizedResult = normalizeNotifications(result)
      dispatch(fetchNotificationsSuccess(normalizedResult))
    })
    .catch((err) => dispatch(fetchNotificationsFail(err)))
}

export const operationMarkNotificationsAsRead =
  (notificationEventIds = []) =>
  (dispatch, getState) => {
    dispatch(markAsRead(notificationEventIds))

    if (selectors.getAreAllMessagesRead(getState())) {
      dispatch(allMessagesRead())
    }

    return markNotificationsAsRead(notificationEventIds).catch((err) =>
      consoleEvents.error('Could not mark notifications as read', err),
    )
  }
